<template>
  <div class="results-score-main">
    <TemplateOne v-if="useTemplateOne" :quiz="quiz"></TemplateOne>
    <TemplateTwo v-if="useTemplateTwo" :quiz="quiz"></TemplateTwo>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import TemplateOne from './components/TemplateOne.vue';
import TemplateTwo from './components/TemplateTwo.vue';

export default {
  components: {
    TemplateOne,
    TemplateTwo,
  },
  props: {
    quiz: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      useTemplateOne: false,
      useTemplateTwo: false,
    };
  },
  created() {
    this.selectTemplate();
    this.onUpdateLessonActivity();
  },
  methods: {
    ...mapActions({
      updateLessonActivity: 'lessonActivity/FETCH_UPDATE',
    }),
    onUpdateLessonActivity() {
      this.updateLessonActivity({
        id: localStorage.getItem('lessonActivityId'),
        data: {
          quiz_presented: true,
          quiz_score: this.$parent.average,
        },
      });
    },
    /** Se determina que template usar para mostrar el score result del quiz */
    selectTemplate() {
      if (
        this.$route.params.grade === 'first-grade' ||
        this.$route.params.grade === 'second-grade' ||
        this.$route.params.grade === 'third-grade' ||
        this.$route.params.grade === 'fourth-grade'
      ) {
        this.useTemplateTwo = true;
      } else {
        this.useTemplateOne = true;
      }
    },
  },
};
</script>
<style lang="sass" scoped>
.results-score-main
  height: 500px
  position: relative
// h1 {
//   margin: 6% 0 1% 0;
//   font-size: 24px;
//   font-family: comfortaabold;
// }
// h2 {
//   margin: 6% 0 1% 0;
//   font-size: 20px;
//   font-family: comfortaabold;
//   max-width: 100%;
// }
// .background {
//   position: absolute;
//   top: 22px;
//   bottom: 66px;
//   // background-image: url("@/assets/tests/elements-1-4/Asset-16.png");
//   width: 100%;
//   /* Full height */
//   height: 94%;

//   /* Center and scale the image nicely */
//   background-position: center;
//   background-repeat: no-repeat;
//   background-size: contain;
// }
// .backgroundTwo {
//   position: absolute;
//   top: 22px;
//   bottom: 66px;
//   // background-image: url(@/assets/tests/elements-1-4/sapceBACK3.png);
//   width: 100%;
//   /* Full height */
//   height: 94%;

//   /* Center and scale the image nicely */
//   background-position: center;
//   background-repeat: no-repeat;
//   background-size: contain;
// }
// .backgroundThree {
//   position: absolute;
//   top: 22px;
//   bottom: 66px;
//   background-image: url(@/assets/tests/elements-5-12/ribbon4.png);
//   width: 100%;
//   /* Full height */
//   height: 94%;

//   /* Center and scale the image nicely */
//   background-position: center;
//   background-repeat: no-repeat;
//   background-size: contain;
// }
// .content {
//   color: black;
//   width: 26%;
//   height: 93%;
//   position: absolute;
//   left: 37%;
//   top: 88%;
//   border-radius: 13px;
//   opacity: 0.8;
//   background: white;
//   max-height: 78%;
// }
// .star {
//   position: absolute;
//   top: 72%;
//   left: 15%;
//   color: white;
// }
// .starTwo {
//   position: absolute;
//   top: 69%;
//   left: 25%;
//   color: white;
// }
</style>
